import { Trans, useTranslation } from "react-i18next";
import defaultContent from "../../../../../content/foundersPlatinumProgressTile";
import { LeafModal } from "../../../../../common/leaf/LeafModal/LeafModal";
import { AwardProgressBadge } from "../../../../../common/components/AwardProgressBadge/AwardProgressBadge";
import { AWARD_PROGRESS } from "../../../../../common/enums/award-progress-codes";
import { TimeStamp } from "../../../../../common/components/TimeStamp/TimeStamp";
import { GpvRequirementTile } from "./GpvRequirementTile/GpvRequirementTile";
import { VepvRequirementTile } from "./VepvRequirementTile/VepvRequirementTile";
import "./FoundersPlatinumProgress.scss";
import type { FoundersPlatinumProgressResponse } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";
import { SpMonthsRequirementTile } from "./SpMonthsRequirementTile/SpMonthsRequirementTile";

type Props = {
  show: boolean;
  onCloseClick: Function;
  status: AWARD_PROGRESS;
  data: FoundersPlatinumProgressResponse;
};

export const FoundersPlatinumProgress = ({ show, onCloseClick, status, data }: Props) => {
  const { t } = useTranslation(["foundersPlatinumProgressTile"]);
  const title = t("foundersPlatinumProgressLabel", defaultContent["foundersPlatinumProgressLabel"]).toString();

  const { SpMonthsRequirement, GpvRequirement, VepvRequirement } = data;
  const { MonthsRequired: gpvTarget, AnnualGpvRequired } = GpvRequirement;
  const { MonthsRequired: vePvTarget, AnnualVepvRequired } = VepvRequirement;
  const { MonthsRequired: spMonthsTarget } = SpMonthsRequirement;

  return show ? (
    <div className="Fpp">
      <LeafModal open={show} onCloseCallbackFn={onCloseClick} title={title} id={"Fpp"}>
        <>
          <div className="Fpp__description">
            <Trans>
              {t("headerLabel", defaultContent["headerLabel"], {})}
              <span className="Fpp__bold-text"></span>
            </Trans>
          </div>
          <div className="Fpp__sub-description">
            <AwardProgressBadge status={status} id={`foundersPlatModalBadge__${status}`} />
            <TimeStamp dateFormat={"bigEndian"} />
          </div>
          <div className="Fpp__tiles-section">
            <SpMonthsRequirementTile spRequirementTileData={SpMonthsRequirement} />
            <GpvRequirementTile gpvRequirementData={GpvRequirement} />
            <VepvRequirementTile vepvRequirementData={VepvRequirement} />
          </div>
          <div className="Fpp__tooltip">
            <div className="Fpp__tooltip-title">
              {t("tooltips.spMonths.tooltipTitle", defaultContent.tooltips.spMonths.tooltipTitle, {
                spMonthsTarget,
              })}
            </div>
            <div className="Fpp__tooltip-desc">
              {t("tooltips.spMonths.tooltipDesc", defaultContent.tooltips.spMonths.tooltipDesc, {
                spMonthsTarget,
              })}
            </div>
          </div>
          <div className="Fpp__tooltip">
            <div className="Fpp__tooltip-title">
              {t("tooltips.gpvMonths.tooltipTitle", defaultContent.tooltips.gpvMonths.tooltipTitle).toString()}
            </div>
            <div className="Fpp__tooltip-desc">
              {t("tooltips.gpvMonths.tooltipDesc", defaultContent.tooltips.gpvMonths.tooltipDesc, {
                gpvMethodMonthsRequired: gpvTarget,
                gpvTarget: AnnualGpvRequired.toLocaleString(),
              })}
              <div>{t("disclaimerLabel", defaultContent["disclaimerLabel"]).toString()}</div>
            </div>
          </div>
          <div className="Fpp__tooltip">
            <div className="Fpp__tooltip-title">
              {t("tooltips.vepvMonths.tooltipTitle", defaultContent.tooltips.vepvMonths.tooltipTitle).toString()}
            </div>
            <div className="Fpp__tooltip-desc">
              {t("tooltips.vepvMonths.tooltipDesc", defaultContent.tooltips.vepvMonths.tooltipDesc, {
                vepvMethodMonthsRequired: vePvTarget,
                vePvTarget: AnnualVepvRequired.toLocaleString(),
              })}
            </div>
          </div>
        </>
      </LeafModal>
    </div>
  ) : (
    <></>
  );
};
